import React from "react";

const ModalContext = React.createContext({
  modalBasePath: "/",
  modalParams: {},
  hidden: false,
});
export default ModalContext;
